import { render, staticRenderFns } from "./ModalSimple.vue?vue&type=template&id=3cbbd1ba&scoped=true&"
import script from "./ModalSimple.vue?vue&type=script&lang=ts&"
export * from "./ModalSimple.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSimple.vue?vue&type=style&index=0&id=3cbbd1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbbd1ba",
  null
  
)

export default component.exports